class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();

    this.subscriptionFrequency = this.querySelector("[js-subscription-frequency]");
    this.frequencySelect = this.querySelector("[js-subscription-frequency-select]");
    this.sellingPlanField = this.querySelector("[js-selling-plan-field]");
    this.frequencySelectLabel = this.querySelector("[js-frequency-select-label]");
    this.subscriptionPrice = document.querySelector("[js-subscription-price]");
    this.regularPrice = document.querySelector("[js-regular-price]");
    this.sellingPlanItems = this.querySelectorAll("[js-selling-plan-item]");

    // Bind once so addEventListener / removeEventListener use the same reference.
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  init() {
    if (!this.subscriptionFrequency || !this.frequencySelect) return;

    this.frequencySelect.addEventListener("click", (e) => {
      // The select lives inside <label for="subscription-purchase">. Without
      // preventDefault the label re-fires a synthetic click on the radio, which
      // (in some browsers) closes the dropdown the instant it opens.
      e.preventDefault();
      e.stopPropagation();

      const isOpen = this.subscriptionFrequency.classList.contains("is-open");
      this.toggleDropdown(!isOpen);
    });

    this.sellingPlanItems.forEach((item) =>
      item.addEventListener("click", this.handleSellingPlan.bind(this))
    );

    this.addEventListener("change", this.handlePrice.bind(this));

    // Use the already-bound reference (so disconnectedCallback can remove it).
    document.addEventListener("click", this.handleOutsideClick);
  }

  toggleDropdown(open) {
    if (!this.subscriptionFrequency) return;

    if (open === true) {
      this.subscriptionFrequency.classList.add("is-open");
    } else if (open === false) {
      this.subscriptionFrequency.classList.remove("is-open");
    } else {
      this.subscriptionFrequency.classList.toggle("is-open");
    }
  }

  handleOutsideClick(e) {
    if (this.frequencySelect.contains(e.target)) return;
    this.toggleDropdown(false);
  }

  handleSellingPlan({ currentTarget }) {
    this.updateMasterId(currentTarget);
    this.updateFrequencylabel(currentTarget);
  }

  updateFrequencylabel(item) {
    const name = item.getAttribute("data-selling-plan-name");
    if (!name || !this.frequencySelectLabel) return;
    this.frequencySelectLabel.textContent = name;
  }

  updateMasterId(item) {
    const id = item.getAttribute("data-selling-plan-id");
    if (!id || !this.sellingPlanField) return;
    this.sellingPlanField.value = id;
  }

  handlePrice({ target }) {
    if (!this.subscriptionPrice || !this.regularPrice) return;

    if (target.getAttribute("is") === "one-time") {
      this.subscriptionPrice.classList.add("hidden");
      this.regularPrice.classList.remove("hidden");
    } else {
      this.subscriptionPrice.classList.remove("hidden");
      this.regularPrice.classList.add("hidden");
    }
  }
}

customElements.define("subscription-widget", SubscriptionWidget);